export default __webpack_public_path__ + "bc9ed4bb662b65a9fb459dba9cda3e09.jpg";